import { RefObject, useEffect } from 'react'

import { batchedAnalytics } from '../utils/batched-analytics'

export const useBatchedAnalyticsCaptureForCategoryCard = ({
  tracker,
  wrapperRef,
  isVisible,
  title,
  position,
}: {
  tracker: string | undefined
  wrapperRef: RefObject<HTMLDivElement>
  title: string | undefined
  isVisible: boolean
  position: number | undefined
}) => {
  useEffect(() => {
    if (tracker && wrapperRef.current && isVisible) {
      batchedAnalytics.pushEventToBatchedAnalyticsStream({
        tracker: tracker,
        event: {
          title,
          position,
        },
      })
    }
  }, [isVisible, tracker, wrapperRef, title, position])
}
